/**
 * The rich sticky header this file originally exported was pulled — it
 * ate too much vertical space from the right pane. All that remains
 * (and all any consumer imports) is the theme-token table below, which
 * `SidebarIdentity` and `ProgramSidebar` both use to color themselves.
 */
import { COLORS } from 'shared/design-system/settings/variables/Colors';

export type WizardThemeKey = 'snapshot' | 'program';

export interface WizardThemeTokens {
  accent: string;
  accentHover: string;
  accentSubdued: string;
  accentBackground: string;
  kicker: string;
  gradient: string;
}

/**
 * Two visual identities for the shared question-wizard chrome:
 *  - `snapshot` (blue) frames the flow as a report the NPO submits.
 *  - `program`  (orange) frames the flow as the program profile that
 *    every report reads its shared answers from.
 * Everything downstream (sidebar highlights, header stripe, progress
 * bar, kicker chip) picks its colors from here so the two modals feel
 * clearly distinct without duplicating layout.
 */
export const WIZARD_THEMES: Record<WizardThemeKey, WizardThemeTokens> = {
  snapshot: {
    accent: COLORS.ctaPrimary,
    accentHover: COLORS.ctaPrimaryHover,
    accentSubdued: COLORS.ctaPrimarySubdued,
    accentBackground: COLORS.ctaPrimaryBackground,
    kicker: 'Impact Snapshot',
    gradient: COLORS.ctaPrimaryGradient,
  },
  program: {
    accent: COLORS.brandPrimary,
    accentHover: COLORS.brandPrimary,
    accentSubdued: COLORS.brandPrimarySubdued,
    accentBackground: COLORS.brandPrimaryBackground,
    kicker: 'Program Profile',
    gradient: COLORS.ctaBrandGradient,
  },
};
